import { render, staticRenderFns } from "./ExtractionSchemeQc.vue?vue&type=template&id=563f6eca&scoped=true"
import script from "./ExtractionSchemeQc.vue?vue&type=script&lang=js"
export * from "./ExtractionSchemeQc.vue?vue&type=script&lang=js"
import style0 from "./ExtractionSchemeQc.vue?vue&type=style&index=0&id=563f6eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f6eca",
  null
  
)

export default component.exports